import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTooltipTail = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 12,
	viewBox: "0 0 40 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M17.9797 5.57177L13.9272 8.34066C11.9506 9.69117 10.9623 10.3664 9.80897 10.8493C8.78643 11.2775 7.67164 11.593 6.50551 11.7842C5.19022 12 3.79256 12 0.99724 12H39.0028C36.2074 12 34.8098 12 33.4945 11.7842C32.3284 11.593 31.2136 11.2775 30.191 10.8493C29.0377 10.3664 28.0494 9.69117 26.0728 8.34066L22.0203 5.57177C20.9045 4.80941 19.0955 4.80941 17.9797 5.57177Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M39.0028 11.021C36.1394 11.021 34.9406 11.0147 33.828 10.8316C32.8076 10.6638 31.8322 10.3869 30.9375 10.0111C29.9618 9.60141 29.1076 9.02493 27.083 7.63742L23.0305 4.86023C21.3568 3.71325 18.6432 3.71326 16.9695 4.86023L12.917 7.63742C10.8924 9.02494 10.0382 9.60141 9.06254 10.0111C8.16782 10.3869 7.19238 10.6638 6.17202 10.8316C5.05938 11.0147 3.86056 11.021 0.99724 11.021H0V12H0.99724C3.79256 12 5.19022 12 6.50551 11.7836C7.67164 11.5917 8.78643 11.2753 9.80897 10.8459C10.9623 10.3615 11.9506 9.68424 13.9272 8.32968L17.9797 5.55249C19.0955 4.78784 20.9045 4.78784 22.0203 5.55249L26.0728 8.32968C28.0494 9.68424 29.0377 10.3615 30.191 10.8459C31.2136 11.2753 32.3284 11.5917 33.4945 11.7836C34.8098 12 36.2074 12 39.0028 12H40V11.021H39.0028Z",
			fill: "#E2E2E8"
		})
	]
});
const ForwardRef = forwardRef(SvgTooltipTail);
export default ForwardRef;
